import Lenis from 'lenis'

export function smoothScroll() {
  const lenis = new Lenis({
    autoRaf: true,
  });

  return lenis;
}
